<form autocomplete="off" class="form" (submit)="onSubmit($event)">
  <div class="field is-narrow">
    <label class="label" translationEditableDirective="CURRENT_DATA_CYCLE">{{"CURRENT_DATA_CYCLE" | translate}}</label>
    <div class="control">
      <ng-select
        [items]="dataCycles"
        [multiple]="false"
        [closeOnSelect]="true"
        (change)="handleFieldChange($event?.id, 'currentDataCycleId')"
        [ngClass]="{ 'is-danger': hasError('currentDataCycleId') }"
        bindLabel="name"
        bindValue="id"
        [ngModelOptions]="{ standalone: true }"
        [ngModel]="getField(['currentDataCycleId'])"
      >
      </ng-select>
    </div>
    <p class="help is-danger" *ngIf="hasError('currentDataCycleId')">
      {{ getError('currentDataCycleId') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="ROUNDING_FACTOR">{{"ROUNDING_FACTOR" | translate}}</label>
    <div class="control">
      <ng-select
        [items]="roundFactors"
        [multiple]="false"
        [closeOnSelect]="true"
        (change)="handleFieldChange($event?.value, 'roundFactor')"
        [ngClass]="{ 'is-danger': hasError('roundFactor') }"
        bindLabel="text"
        bindValue="value"
        [ngModelOptions]="{ standalone: true }"
        [ngModel]="getField(['roundFactor'])"
      >
      </ng-select>
    </div>
    <p class="help is-danger" *ngIf="hasError('roundFactor')">
      {{ getError('roundFactor') }}
    </p>
  </div>

  <div class="field is-narrow">
    <label class="label" translationEditableDirective="CLIENT_BASE_URL">{{"CLIENT_BASE_URL" | translate}}</label>
    <div class="control">
      <input
        class="input"
        name="clientBaseUrl"
        type="text"
        (input)="handleFieldChange($event)"
        [value]="getField(['clientBaseUrl'])"
        [ngClass]="{ 'is-danger': hasError('clientBaseUrl') }"
      />
    </div>
    <p class="help is-danger" *ngIf="hasError('clientBaseUrl')">
      {{ getError('clientBaseUrl') }}
    </p>
  </div>

  <div class="field is-grouped">
    <div class="control">
      <button [disabled]="isLoading" type="submit" class="button is-link" translationEditableDirective="SAVE">{{"SAVE" | translate}}
      </button>
    </div>
  </div>
</form>
